import React, { useEffect, useRef, useState } from 'react';

export default function Floating({
  children,
  containerRef,
  active,
}: {
  children: (
    floating: boolean,
    leftRef: React.MutableRefObject<HTMLDivElement | null>,
    rightRef: React.MutableRefObject<HTMLDivElement | null>,
    topRef: React.MutableRefObject<HTMLTableSectionElement | null>,
  ) => JSX.Element;
  containerRef: React.MutableRefObject<HTMLDivElement | null>;
  active: boolean;
}): JSX.Element {
  const [isFloating, setIsFloating] = useState(false);
  const leftRef = useRef<HTMLDivElement>(null);
  const rightRef = useRef<HTMLDivElement>(null);
  const topRef = useRef<HTMLTableSectionElement>(null);
  useEffect(() => {
    const container = containerRef.current;
    const leftTarget = leftRef.current;
    const rightTarget = rightRef.current;
    if (!active || !('IntersectionObserver' in window) || !container || !leftTarget || !rightTarget) {
      return () => {};
    }
    const observer = new IntersectionObserver(
      (entries) => {
        const allIntersecting = !entries.find((entry) => !entry.isIntersecting);
        setIsFloating(!allIntersecting);
      },
      {
        root: container,
        threshold: 1.0,
      },
    );
    observer.observe(leftTarget);
    observer.observe(rightTarget);
    return () => {
      observer.unobserve(leftTarget);
      observer.unobserve(rightTarget);
    };
  });
  useEffect(() => {
    const topTarget = topRef.current;
    if (!active || !('IntersectionObserver' in window) || !topTarget) {
      return () => {};
    }
    const observer = new IntersectionObserver(
      (entries) => {
        const allIntersecting = !entries.find((entry) => !entry.isIntersecting);
        setIsFloating(!allIntersecting);
      },
      {
        root: null,
        threshold: 1.0,
      },
    );
    observer.observe(topTarget);
    return () => {
      observer.unobserve(topTarget);
    };
  });
  return children(isFloating, leftRef, rightRef, topRef);
}
